var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4112 16 16 12.4112 16 8C16 3.58879 12.4112 0 8 0C3.58879 0 0 3.58879 0 8C0 12.4112 3.58879 16 8 16ZM8 1.03595C11.84 1.03595 14.964 4.16015 14.964 8C14.964 11.8399 11.84 14.964 8 14.964C4.15998 14.964 1.03595 11.8399 1.03595 8C1.03595 4.16015 4.15998 1.03595 8 1.03595ZM4.11515 8.99384H9.37241C9.37241 8.99384 8.09799 10.2684 7.30856 11.0575C6.97153 11.3947 6.97153 11.9414 7.30856 12.2786C7.36416 12.3342 7.42044 12.3903 7.47604 12.4459C7.81307 12.7831 8.35973 12.7831 8.69696 12.4459C9.73017 11.4128 11.7805 9.36227 12.4954 8.64729C12.6573 8.4855 12.7483 8.26588 12.7483 8.03693V7.96304C12.7483 7.73426 12.6573 7.51464 12.4954 7.35268C11.7805 6.63783 9.73017 4.5873 8.69696 3.55423C8.35973 3.21703 7.81307 3.21703 7.47604 3.55423C7.42044 3.60966 7.36416 3.66614 7.30856 3.72154C6.97153 4.05877 6.97153 4.60526 7.30856 4.94245C8.09799 5.73171 9.37241 7.0063 9.37241 7.0063H4.11515C3.63825 7.0063 3.25183 7.3929 3.25183 7.86962V8.13052C3.25183 8.60741 3.63825 8.99384 4.11515 8.99384Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlMore);
export default __webpack_public_path__ + "static/media/sl_more.4994e12a5eef428b336d6a715cd61574.svg";
export { ForwardRef as ReactComponent };